module.exports = __webpack_public_path__ + "static/img/category-select-logo.8f5e54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/category-select-logo.png
// module id = i/Hu
// module chunks = 1